const svgNameSpaceURI = `http://www.w3.org/2000/svg`
export { svgNameSpaceURI }
